import { IState } from '../../store';

export const selectDIYEnabled = (state: IState): boolean => state.newbuildingBrokerDIY.enabled;
